import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTrans } from '../../../../services/i18n';
import { shouldShowMfaReminderBanner } from '../../../../utils/mfa';
import { dismissMfaReminderBanner } from '../../../../utils/mfaReminderBanner';
import { ANNOUNCEMENT_BANNER_COLORS } from '../../../../utils/announcementBannerUtils';

const MfaReminderBanner = () => {
  const { trans } = useTrans();
  const auth = useSelector((state) => state.auth || {});
  const [dismissed, setDismissed] = React.useState(false);

  const showBanner = !dismissed && shouldShowMfaReminderBanner(auth);

  const onDismiss = React.useCallback(() => {
    dismissMfaReminderBanner(auth.username);
    setDismissed(true);
  }, [auth.username]);

  if (!showBanner) {
    return null;
  }

  const colors = ANNOUNCEMENT_BANNER_COLORS.yellow;

  return (
    <div
      style={{
        background: colors.background,
        borderBottom: `1px solid ${colors.border}`,
        borderRadius: 0,
        padding: '16px 64px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '24px',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ paddingRight: '24px' }}>
        <div
          style={{
            color: colors.title,
            fontSize: '15px',
            fontWeight: 700,
            lineHeight: 1.4,
            marginBottom: '4px',
          }}
        >
          {trans('mfa-reminder-banner-title')}
        </div>
        <div
          style={{
            color: '#1f2937',
            fontSize: '15px',
            fontWeight: 500,
            lineHeight: 1.5,
          }}
        >
          {trans('mfa-reminder-banner-message')}{' '}
          <Link to="/profile" style={{ color: colors.title, fontWeight: 600 }}>
            {trans('mfa-reminder-banner-profile-link')}
          </Link>
        </div>
      </div>

      <IconButton
        size="small"
        onClick={onDismiss}
        style={{
          color: '#8a94a6',
          padding: '4px',
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </div>
  );
};

export default MfaReminderBanner;
